import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SignInComponent } from './sign-in/sign-in.component';
import { WaiverRegisterComponent } from './resident-details/waiver-register/waiver-register.component';
import { OfficerSearchDetailsComponent } from './officer-search-details/officer-search-details.component';
import { VillageStaffComponent } from './village-staff/village-staff.component';
import { AuthenticationGuard as AuthGuard } from './authentication/authentication.guard'
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ErrorComponent } from './shared/common-components/error/error.component';
import { ChangePasswordComponent } from './forgot-password/change-password/change-password.component';
import { HomeComponent } from './home/home.component';

const routes: Routes = [
  { path: '', redirectTo: '/create-waiver', pathMatch: 'full' },
  { path: '', redirectTo: '/sign-in', pathMatch: 'full' },
  { path: 'create-waiver', component: WaiverRegisterComponent },
  // { path: "volo-home", component: HomeComponent },
  { path: "sign-in", component: HomeComponent },
  { path: "login", component: SignInComponent },
  // { path: 'vehicle-search', component: OfficerSearchDetailsComponent, canActivate: [AuthGuard] },
  // { path: 'village-staff', component: VillageStaffComponent, canActivate: [AuthGuard] },
  { path: 'officer', component: OfficerSearchDetailsComponent, canActivate: [AuthGuard] },
  { path: 'staff', component: VillageStaffComponent, canActivate: [AuthGuard] },
  { path: 'forgot-pwd', component: ForgotPasswordComponent },
  { path: 'error-404', component: ErrorComponent },
  { path: 'change-password/:id', component: ChangePasswordComponent },




];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
